<template>
  <div style="width: 700px">
    <el-row>
      <el-col :span="24">
        <el-card class="box-card" style="width: 750px; margin: 0px auto">
          <div slot="header" class="clearfix">
            <span>报价器-王者荣耀</span>
          </div>
          <el-tabs v-model="activeType" type="card" @tab-click="tabSelect">
            <el-tab-pane label="段位代练(F1)" name="Dan">
              <div>
                <KingForm
                  ref="danKingForm"
                  :zone.sync="zone"
                  :server.sync="server"
                  :inscription-id.sync="inscriptionId"
                  :inscriptions="inscriptions"
                  :star-count="starCount"
                  :selected-dans="selectedDans"
                  :dan-star="danStar"
                  :show-estimate-time.sync="showEstimateTime"
                  :show-first-dan.sync="showFirstDan"
                  :discount.sync="discount"
                  :discounts="discounts"
                  :change-start-count="changeStartCount"
                  :change-end-count="changeEndCount"
                  :dans="dans"
                  :handle-selected="handleSelected"
                  :handle-over-king="handleOverKing" />
              </div>
            </el-tab-pane>
            <el-tab-pane label="段位陪练(F2)" name="PartnerDan">
              <div>
                <KingForm
                  ref="kingForm"
                  :zone.sync="zone"
                  :server.sync="server"
                  :inscription-id.sync="inscriptionId"
                  :inscriptions="inscriptions"
                  :star-count="starCount"
                  :selected-dans="selectedDans"
                  :dan-star="danStar"
                  :show-estimate-time.sync="showEstimateTime"
                  :show-first-dan.sync="showFirstDan"
                  :discount.sync="discount"
                  :discounts="discounts"
                  :change-start-count="changeStartCount"
                  :change-end-count="changeEndCount"
                  :dans="dans"
                  :handle-selected="handleSelected"
                  :handle-over-king="handleOverKing" />
              </div>
            </el-tab-pane>
            <el-tab-pane label="巅峰赛(F3)" name="Summit">
              <summit ref="fromSummit"></summit>
            </el-tab-pane>
            <el-tab-pane label="战力(F4)" name="Battle">
              <battle ref="fromBattle"></battle>
            </el-tab-pane>
          </el-tabs>
          <div class="mt10">
            <el-row>
              <el-col :span="24">
                <div style="float: right">
                  <el-button type="primary" @click="debouncedGenPriceAndCopy" style="margin-left: 5px" class="btnGen" id="btnGen" ref="btnGen">
                    生成报价+复制报价
                    <span v-if="shortcutKeys['生成报价+复制报价']" class="shortcut-hint">({{ shortcutKeys['生成报价+复制报价'] }})</span>
                  </el-button>
                  <el-button type="primary" @click="debouncedGokTotalPrice" style="margin-left: 5px" class="btnGen">
                    整单优惠
                    <span v-if="shortcutKeys['整单优惠']" class="shortcut-hint">({{ shortcutKeys['整单优惠'] }})</span>
                  </el-button>
                  <el-button id="btnCopy" @click="debouncedDoCopy" ref="btnCopy">
                    复制报价
                    <span v-if="shortcutKeys['复制报价']" class="shortcut-hint1">({{ shortcutKeys['复制报价'] }})</span>
                  </el-button>
                  <el-button @click="debouncedReset" id="btnReset">
                    重置查询
                    <span v-if="shortcutKeys['重置查询']" class="shortcut-hint1">({{ shortcutKeys['重置查询'] }})</span>
                  </el-button>
                </div>
              </el-col>
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="24">
                <el-input type="textarea" :row="5" placeholder="报价内容" v-model="content" :autosize="{ minRows: 3, maxRows: 10 }"></el-input>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div style="margin-top: 10px; margin-left: 10px; text-align: center">
      <el-alert :title="shortcutTip" type="success" center show-icon></el-alert>
    </div>
  </div>
</template>

<script>
  import Dan from '../components/Dan';
  import Battle from '../components/king/battle';
  import Summit from '../components/king/summit';
  import KingForm from '../components/king/king-form';
  import { ShortcutListener, getUserKeys, keyCodeToName } from '../utils/keyHelp';

  export default {
    name: 'king',
    components: { Battle, Summit, KingForm },
    data() {
      return {
        gameId: 17,
        dans: this.$store.state.dans,
        selectedDans: [],
        zone: 'ANDRIOD',
        server: 'QQ',
        inscriptionId: 0,
        inscriptions: [],
        showEstimateTime: true,
        content: '',
        activeType: 'Dan',
        prompt: true,
        discountType: 'NORMAL',
        shortcutListener: null,
        shortcutKeys: {},
        starCount: {
          startStar: {
            label: '起始',
            count: 1,
          },
          endStar: {
            label: '结束',
            count: 1,
          },
          keyNum: 1,
        },
        keyStar: true,
        startStarCountClass: {},
        endStarCountClass: {},
        //keyValue: {},
        //keyKingValue: '',
        oldDan: [],
        //isKeyDan: true,
        showFirstDan: true,
        pricingId: 'GOK_LEVELING',
        danStar: 0,
        //折扣
        discount: null,
        discounts: [],
      };
    },
    watch: {
      'starCount.startStar': {
        handler(val, oldVal) {
          if (val != null && this.selectedDans[0]) {
            this.selectedDans[0].count = val.count;
          }
        },
        deep: true,
      },
      'starCount.endStar': {
        handler(val, oldVal) {
          if (val != null && this.selectedDans[1]) {
            this.selectedDans[1].count = val.count;
          }
        },
        deep: true,
      },
    },
    created() {
      // 创建防抖版本的方法
      this.debouncedGenPriceAndCopy = this.debounce(this.genPriceAndCopy, 300);
      this.debouncedGokTotalPrice = this.debounce(this.gokTotalPrice, 300);
      this.debouncedDoCopy = this.debounce(this.doCopy, 300);
      this.debouncedReset = this.debounce(this.reset, 300);
    },
    mounted() {
      this.loadInscriptions();
      this.getDiscount();
      this.loadQuoterTextFormat();
      this.initShortcuts();
    },
    computed: {
      sortedSelectedDans() {
        let target = [];

        Object.assign(target, this.selectedDans);
        target.sort((x, y) => {
          let xDanIndex = this.dans.findIndex(i => {
            return i.name === x.dan;
          });
          let yDanIndex = this.dans.findIndex(i => {
            return i.name === y.dan;
          });

          return xDanIndex - yDanIndex;
        });

        return target;
      },
    },
    computed: {
      shortcutTip() {
        const tips = [];
        if (this.shortcutKeys['生成报价+复制报价']) {
          tips.push(`${this.shortcutKeys['生成报价+复制报价']}=生成报价+复制报价`);
        }
        if (this.shortcutKeys['复制报价']) {
          tips.push(`${this.shortcutKeys['复制报价']}=复制报价`);
        }
        if (this.shortcutKeys['整单优惠']) {
          tips.push(`${this.shortcutKeys['整单优惠']}=整单优惠`);
        }
        if (this.shortcutKeys['重置查询']) {
          tips.push(`${this.shortcutKeys['重置查询']}=重置查询`);
        }
        return tips.length > 0 ? tips.join(', ') : '快捷键提示';
      },
    },
    methods: {
      // 防抖函数
      debounce(func, delay = 300) {
        let timer = null;
        return function (...args) {
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(() => {
            func.apply(this, args);
            timer = null;
          }, delay);
        };
      },
      // 初始化快捷键
      initShortcuts() {
        const user = this.$store.getters['user'];
        const defaultKeys = this.$store.getters['keys'];
        const keys = getUserKeys(user.accountNo, defaultKeys);

        // 构建快捷键显示映射
        keys.forEach(key => {
          this.shortcutKeys[key.name] = keyCodeToName(key.keyCode);
        });

        // 创建快捷键监听器(带防抖)
        this.shortcutListener = new ShortcutListener(keys, {
          '生成报价+复制报价': this.debouncedGenPriceAndCopy,
          整单优惠: this.debouncedGokTotalPrice,
          复制报价: this.debouncedDoCopy,
          重置查询: this.debouncedReset,
        });

        // 开始监听
        this.shortcutListener.start();
      },
      // 生成报价并复制
      genPriceAndCopy() {
        this.genPrice();
      },
      loadInscriptions() {
        let url = `/api/company/inscriptions?gameId=${this.gameId}&pricingType=${this.pricingId}`;

        this.$http.get(url).then(res => {
          this.inscriptions = res.data;
          if (this.inscriptions.length > 0) {
            this.inscriptionId = this.inscriptions[0].id;
          }
        });
      },
      loadQuoterTextFormat() {
        let url = `/api/company/format?gameId=${this.gameId}&pricingType=${this.pricingId}`;

        this.$http.get(url).then(res => {
          let data = res.data;

          if (data != null) {
            this.showEstimateTime = data.showEstimateTime;
          }
        });
      },
      handleSelected(value) {
        let index = this.selectedDans.findIndex(x => {
          return x.dan === value.dan && x.subDan === value.subDan;
        });

        if (index === -1) {
          if (this.selectedDans.length === 2) {
            this.selectedDans.splice(0, 1);
          }
          this.selectedDans.push(value);
        } else {
          this.selectedDans.splice(index, 1);
        }

        if (this.selectedDans.length == 1) {
          this.selectedDans.push(this.selectedDans[0]);
        }
        // 排序所选段位
        this.sortSelectedDans();
        // 设置默认星颗数
        this.starCount.startStar.label = this.selectedDans[0].label;
        this.starCount.startStar.count = this.selectedDans[0].count;
        this.starCount.endStar.label = this.selectedDans[1].label;
        this.starCount.endStar.count = this.selectedDans[1].count;
        this.calcDanStarCount();
      },
      handleOverKing() {
        this.selectedDans.length = 0;
        this.selectedDans.push({ dan: '王者', subDan: '1星', starCount: 1000, label: '王者', level: 6, count: 1 });
        this.selectedDans.push({ dan: '王者', subDan: '1星', starCount: 1000, label: '王者', level: 6, count: 1 });
        // 设置默认星颗数
        this.starCount.startStar.label = this.selectedDans[0].label;
        this.starCount.startStar.count = this.selectedDans[0].count;
        this.starCount.endStar.label = this.selectedDans[1].label;
        this.starCount.endStar.count = this.selectedDans[1].count;
        this.calcDanStarCount();
        //console.log('王者上星', JSON.stringify(this.selectedDans));
      },
      // 对选取的段位重排序
      sortSelectedDans() {
        if (this.selectedDans.length < 2) {
          return;
        }
        // 比较大段位，并排序
        if (this.selectedDans[0].level > this.selectedDans[1].level) {
          this.selectedDans = [this.selectedDans[1], this.selectedDans[0]];
        }
        //同大段位，小段位排序（比如：钻石5与钻石4， 钻5排在钻石4前面）
        if (this.selectedDans[0].dan == this.selectedDans[1].dan) {
          if (this.selectedDans[0].subDan < this.selectedDans[1].subDan) {
            //解构赋值
            this.selectedDans = [this.selectedDans[1], this.selectedDans[0]];
          }
        }
      },
      // 计算选取的段位的星数
      calcDanStarCount() {
        if (this.selectedDans.length < 2) {
          return;
        }

        const data = {
          fromDan: this.selectedDans[0].label,
          fromStarCount: this.starCount.startStar.count,
          toDan: this.selectedDans[1].label,
          toStarCount: this.starCount.endStar.count,
        };

        if (data.fromDan == data.toDan && data.fromStarCount == data.toStarCount) {
          this.danStar = 0;
          return;
        }

        this.$http.post('/api/gok/price/dan/count', data).then(res => {
          if (res !== null) {
            this.danStar = res.data;
          }
        });
      },
      genPrice(event) {
        //this.isKeyDan = true;
        this.discountType = 'NORMAL';
        if (this.activeType === 'Dan' || this.activeType === 'PartnerDan') {
          this.gokDanPrice();
        } else if (this.activeType === 'Battle') {
          this.gokBattlePrice();
        } else if (this.activeType === 'Summit') {
          this.gokSummitPrice();
        }
      },
      // 代练报价
      gokDanPrice() {
        if (this.selectedDans.length == 0 && this.activeType === 'Dan') {
          this.$message({
            message: '请选择段位！',
            type: 'warning',
          });
          return false;
        }
        let data = {
          pricingId: this.pricingId,
          gameId: this.gameId,
          zone: this.zone,
          server: this.server,
          inscriptionId: this.inscriptionId,

          fromDan: this.selectedDans[0].label,
          fromStarCount: this.starCount.startStar.count,
          endDan: this.selectedDans[1].label,
          endStarCount: this.starCount.endStar.count,

          showTime: this.showEstimateTime,
          showFirstDan: this.showFirstDan,
          discountType: this.discountType,
          discount: this.discount,
        };

        this.$http.post('/api/gok/price/dan/v2', data).then(res => {
          if (res == null) {
            return;
          }
          this.content = res.data;
          this.doCopy(this.content);
          this.$message('代练报价生成成功！');
        });
      },
      //整单优惠报价
      gokTotalPrice() {
        let that = this;
        this.discountType = 'TOTAL';
        if (that.activeType === 'Dan' || that.activeType === 'PartnerDan') {
          that.gokDanPrice();
        } else if (that.activeType === 'Battle') {
          that.gokBattlePrice();
        } else if (that.activeType === 'Summit') {
          that.gokSummitPrice();
        }
      },
      // 战力报价
      gokBattlePrice() {
        let that = this;
        let from = that.$refs['fromBattle'].fromBattle;
        let data = {
          fromPoint: from.fromPoint,
          discountType: this.discountType,
          gameId: that.gameId,
          inscriptionId: from.inscriptionId,
          showTime: from.showTime,
          toPoint: from.toPoint,
          discount: from.discount,
        };
        this.$http.post('/api/gok/price/battle', data).then(res => {
          if (res == null) {
            return;
          }
          this.content = res.data;
          this.doCopy(this.content);
          this.$message('战力报价生成成功！');
        });
      },
      // 巅峰赛报价
      gokSummitPrice() {
        let that = this;
        let from = that.$refs['fromSummit'].fromSummit;
        let data = {
          fromPoint: from.fromPoint,
          discountType: this.discountType,
          gameId: that.gameId,
          inscriptionId: from.inscriptionId,
          showTime: from.showTime,
          toPoint: from.toPoint,
          discount: from.discount,
        };
        this.$http.post('/api/gok/price/summit', data).then(res => {
          if (res == null) {
            return;
          }

          this.content = res.data;
          this.doCopy(this.content);
          this.$message('巅峰报价生成成功！');
        });
      },
      reset() {
        let that = this;
        if (that.activeType === 'Dan' || that.activeType == 'PartnerDan') {
          this.selectedDans = [];
          this.zone = 'ANDRIOD';
          this.server = 'QQ';
          if (this.inscriptions.length > 0) {
            this.inscriptionId = this.inscriptions[0].id;
          }
        } else if (that.activeType === 'Battle') {
          that.$refs['fromBattle'].fromBattle.fromPoint = '';
          if (that.$refs['fromBattle'].fromBattle.inscriptions.length > 0) {
            that.$refs['fromBattle'].fromBattle.inscriptionId = that.$refs['fromBattle'].fromBattle.inscriptions[0].id;
          }
          that.$refs['fromBattle'].fromBattle.showTime = true;
          that.$refs['fromBattle'].fromBattle.toPoint = '';
          that.$nextTick(() => {
            that.$refs['fromBattle'].focus();
          });
        } else if (that.activeType === 'Summit') {
          that.$refs['fromSummit'].fromSummit.fromPoint = '';
          if (that.$refs['fromSummit'].fromSummit.inscriptions.length > 0) {
            that.$refs['fromSummit'].fromSummit.inscriptionId = that.$refs['fromSummit'].fromSummit.inscriptions[0].id;
          }
          that.$refs['fromSummit'].fromSummit.showTime = true;
          that.$refs['fromSummit'].fromSummit.toPoint = '';
          that.$nextTick(() => {
            that.$refs['fromSummit'].focus();
          });
        }
        this.keyStar = true;
        this.startStarCountClass = {};
        this.endStarCountClass = {};
        this.starCount = {
          startStar: {
            label: '起始',
            count: 1,
          },
          endStar: {
            label: '结束',
            count: 1,
          },
          keyNum: 1,
        };
        this.keyStar = true;
        this.startStarCountClass = {};
        this.endStarCountClass = {};
        this.oldDan = [];
        this.$message('重置成功');
      },
      onCopy(e) {
        this.$message('内容已复制到剪切板！');
      },
      // 复制失败时的回调函数
      onError(e) {
        this.$message('抱歉，您的浏览器不支持！');
      },
      doCopy(e) {
        let that = this;
        that.$copyText(this.content).then(
          function (e) {
            that.$message('内容已复制到剪切板');
          },
          function (e) {
            if (that.prompt) {
              that.prompt = false;
              that.$message('您的浏览器不支持自动复制,请点击右侧复制按钮,或下载Chrome浏览器使用！');
            }
          }
        );
      },
      showMessage(msg, duration) {
        let that = this;
        that.$message({
          showClose: true,
          message: msg,
          type: 'warning',
          duration: duration,
        });
      },
      changeStartCount(event) {
        this.calcDanStarCount();
      },
      changeEndCount(event) {
        this.calcDanStarCount();
      },
      tabSelect(event) {
        console.log('event=', event.name);
        this.handleTabChange(event.name);
      },
      handleTabChange(tabName) {
        if (tabName == 'Dan') {
          this.pricingId = 'GOK_LEVELING';
        } else if (tabName == 'PartnerDan') {
          this.pricingId = 'GOK_PARTNER_LEVELING';
        }

        if (tabName == 'Dan' || tabName == 'PartnerDan') {
          this.danStar = 0;
          this.loadInscriptions();
          this.getDiscount();
          this.loadQuoterTextFormat();
          this.$nextTick(() => {
            if (tabName == 'Dan') {
              this.$refs.danKingForm.focus();
            } else {
              this.$refs.kingForm.focus();
            }
          });
        } else if (tabName == 'Summit') {
          this.$nextTick(() => {
            this.$refs.fromSummit.focus();
          });
        } else if (tabName == 'Battle') {
          this.$nextTick(() => {
            this.$refs.fromBattle.focus();
          });
        }
      },
      //获取折扣设置
      getDiscount() {
        let that = this;
        that.discounts = [];
        that.discount = null;
        axios
          .get('/api/company/discount', {
            params: { gameId: that.gameId, pricingType: that.pricingId },
          })
          .then(res => {
            if (res != null) {
              that.discounts = res.data;
            }
            that.discounts.unshift({ name: '不打折', discount: null });
          });
      },
    },
    destroyed() {
      let that = this;
      that.$message.closeAll();
      if (this.shortcutListener) {
        this.shortcutListener.stop();
      }
    },
    beforeDestroy() {
      // 停止快捷键监听
      if (this.shortcutListener) {
        this.shortcutListener.stop();
      }
    },
    activated() {
      console.log('刷新');
    },
  };
</script>

<style lang="stylus" scoped>
  .desc_text {
    height 40px;
    line-height 40px;
    margin-right 5px;
  }

  .active {
    color: rgb(247, 186, 42) !important;
  }

  .shortcut-hint,.shortcut-hint1 {
    font-size: 12px;
    color: #909399;
    margin-left: 4px;
  }
   .shortcut-hint{
    color:#FFF;
   }
</style>
